import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
// Rxjs
import { of, from } from 'rxjs';
import { switchMap, map, catchError, withLatestFrom, take, tap, delay, mergeMap, concatMap } from 'rxjs/operators';
// Store
import { select, Store } from '@ngrx/store';
// State
import { AppState } from '../app.state';
// Actions
import {
  loadFormsList,
  loadFormsListSuccess,
  loadFormsListFailure,
  getSelectedForm,
  getSelectedFormSuccess,
  getSelectedFormFailure,
  deleteForm,
  deleteFormSuccess,
  deleteFormFailure,
  addForm,
  addFormSuccess,
  addFormFailure,
  editForm,
  editFormFailure,
  editFormSuccess,
  cloneForm,
  cloneFormSuccess,
  cloneFormFailure
  } from '../actions/form.actions';

// Models

// Selectors
import { setForms, setSelectedForm } from '../selectors/form.selector';
// Services
import { FormService } from '../../services/form.service';


@Injectable()
export class FormEffects {

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,    
    private router: Router,
    private formService: FormService,
    private toastAlert: ToastrService
  ) { }
  
  loadFormsList$ = createEffect(() =>
    this.actions$.pipe(
    ofType(loadFormsList),
    //withLatestFrom(this.store.select(selectForm)),
    concatMap(() =>
        this.formService.getForms().pipe(
          //tap((data:any) => {console.log('EFFECT loadFormsList->', data)}),
          map((data:any) => loadFormsListSuccess({ data: data })),
          catchError((error) => of(loadFormsListFailure({ error })))
        )
      )
    )
  )

  getSelectedForm$ = createEffect(() =>
    this.actions$.pipe(
    ofType(getSelectedForm),
    concatMap(({ form }) =>
        this.formService.getForm(form).pipe(
          map((data:any) => getSelectedFormSuccess({ form: data })),
          catchError((error) => of(getSelectedFormFailure({ error })))
        )
      )
    )
  )

  DeleteForm$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteForm),
      concatMap(({ form }) =>
        this.formService.deleteForm(form).pipe(          
          map(({ content }) => deleteFormSuccess({ sk:form.sk, pk:form.pk })),
          catchError((error) => of(deleteFormFailure({ error })))
        )
      )
    )
  );

  DeleteFormSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteFormSuccess),
        tap((action) => {
          this.toastAlert.success('Delete form was successful', 'Delete Form');
        })
      ),
    { dispatch: false }
  );

  AddForm$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addForm),
      concatMap(({ form }) =>
        this.formService.addForm(form).pipe(
          map((data:any) => addFormSuccess({ form: data })),
          catchError((error) => of(addFormFailure({ error })))
        )
      )
    )
  );

  AddFormSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(addFormSuccess),
        tap((action) => {
          this.toastAlert.success('Create form was successful', 'Create Form');
        })
      ),
    { dispatch: false }
  );

  EditForm$ = createEffect(() =>
    this.actions$.pipe(
      ofType(editForm),
      concatMap(({ form }) =>
        this.formService.editForm(form).pipe(
          map((data:any) => editFormSuccess({ form: data })),
          catchError((error) => of(editFormFailure({ error })))
        )
      )
    )
  );

  EditFormSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(editFormSuccess),
        tap((action) => {
          this.toastAlert.success('Edit form was successful', 'Edit Form');
        })
      ),
    { dispatch: false }
  );

  CloneForm$ = createEffect(() =>
    this.actions$.pipe(
      ofType(cloneForm),
      concatMap(({ form }) =>
        this.formService.cloneForm(form).pipe(
          map((data:any) => cloneFormSuccess({ form: data })),
          catchError((error) => of(cloneFormFailure({ error })))
        )
      )
    )
  );

  CloneFormSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(cloneFormSuccess),
        tap((action) => {
          this.toastAlert.success('Clone form was successful', 'Clone Form');
        })
      ),
    { dispatch: false }
  );

  FormsError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loadFormsListFailure, getSelectedFormFailure, deleteFormFailure, addFormFailure, editFormFailure, cloneFormFailure),
        tap(({ error }) => {
          const msgError = error.error || 'Internal Error ';
          this.toastAlert.error(msgError, 'Error');
        })
      ),
    { dispatch: false }
  );
 
}